import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { isNativeIOS } from '@/lib/native';
import { useAuth } from '@/lib/auth';

const randomNonce = () => Array.from(crypto.getRandomValues(new Uint8Array(32)), (b) => b.toString(16).padStart(2, '0')).join('');
const sha256Hex = async (s) => Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(s))), (b) => b.toString(16).padStart(2, '0')).join('');

// Solo se muestra en la app iOS (App Review 4.8).
export const AppleSignInButton = ({ role = 'buyer', onSuccess }) => {
  const { appleSignIn } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!isNativeIOS()) return null;

  const signIn = async () => {
    setBusy(true);
    try {
      const raw = randomNonce();
      const { response } = await window.Capacitor.Plugins.SignInWithApple.authorize({
        clientId: 'co.automarketcolombia.app', redirectURI: '', scopes: 'email name',
        state: randomNonce(), nonce: await sha256Hex(raw),
      });
      const user = await appleSignIn({
        identity_token: response.identityToken, authorization_code: response.authorizationCode,
        raw_nonce: raw, given_name: response.givenName, family_name: response.familyName, role,
      });
      onSuccess?.(user);
    } catch (e) {
      if (e?.code !== '1001') toast.error(e.response?.data?.detail || 'No se pudo iniciar sesión con Apple');
    } finally { setBusy(false); }
  };

  return (
    <Button type="button" onClick={signIn} disabled={busy} data-testid="apple-signin-btn"
            className="w-full h-11 rounded-none bg-black hover:bg-slate-900 text-white font-bold">
      {busy ? 'Conectando…' : ' Continuar con Apple'}
    </Button>
  );
};
